import { Link } from "react-router-dom";
import { colors, type, spacing } from "@/theme";
import { CONTACT } from "@/content/site";

const links = [
  ["Privacy", "/privacy"],
  ["Accedi", "/accedi"],
  ["Chi sono", "/chi-sono"],
];

export default function SiteFooter() {
  return (
    <div style={{ borderTop: `1px solid ${colors.rule}`, padding: `${spacing.xl}px 0`, display: "flex", flexDirection: "column", alignItems: "center", gap: spacing.s12 }}>
      <div style={{ ...type.serif, fontSize: 24, color: colors.ink }}>Tavoline</div>
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: spacing.lg }}>
        {links.map(([label, href]) => (
          <Link key={href} data-testid={`footer-${href.slice(1)}`} to={href} style={{ ...type.sansMedium, fontSize: 14, color: colors.ink, textDecoration: "underline" }}>
            {label}
          </Link>
        ))}
      </div>
      <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} style={{ ...type.sansMedium, fontSize: 14, color: colors.ink, textDecoration: "underline" }}>
        {CONTACT.email}
      </a>
    </div>
  );
}
